import { Injectable } from "@angular/core";
import { ApiService } from "@core/services/api.service";
import { IBusiness } from "@shared/models";
import { uriConsts } from "@shared/constants";
import { IResponseApi } from "@app/core/models";

/**
 * Service xử lý dữ liệu
 * - Thông tin doanh nghiệp
 * */
@Injectable({
   providedIn: 'root'
})
export class BusinessService extends ApiService {

   /**
    * Lấy thông tin của DN
    * */
   getBusiness(id: number) {
      return this.postSystemRequest<IResponseApi<IBusiness>>('uriConsts.store.MANAGE_LOAD', {
         tab: 'getBusiness',
         id: id
      });
   }

   /**
    * Suggest doanh nghiệp user quản lý
    * */
   suggestBusinesses(query: string) {
      return this.postSystemRequest<IResponseApi<IBusiness[]>>('uriConsts.store.MANAGE_LOAD', {
         tab: 'suggest',
         q: query
      });
   }

  /**
   * Lấy danh sách location dùng cho checkout guest flow.
   */
  getShippingLocation(type: 'CITY' | 'DISTRICT' | 'WARD', parentId?: number) {
    return this.postSystemRequest<IResponseApi<any>>('/checkout', {
      act: 'getShippingLocation',
      type,
      ...(parentId ? {parentId} : {}),
    });
  }


}
